<template>
  <div class="data-item">
    <h3 class="item-name">{{name}}
      <span class="extra" v-if="extra">{{extra}}</span>
    </h3>
    <div class="item-value">
      <span class="value">{{(value||value===0)?value:'--'}}</span>
      <span class="unit">{{valueUnit}}</span>
    </div>
    <template v-if="hasCompareValue">
      <span class="compare-name">{{compareName}}</span>
      <span class="compare-value" :class="{'lower':isLower,'higher':isHigher}">{{compareValue?compareValue+'%':defaultCompareValue}}</span>
    </template>
  </div>
</template>
<script>
  const defaultCompareValue = "--";
  export default {
      props: {
          name: {
              type: String,
              required: true
          },
          value: {
              type: Number | String,
              default: 0
          },
          valueUnit: {
              type: String,
              required: true
          },
          compareName: {
              type: String,
              default: "较上周同期"
          },
          compareValue: {
              type: String,
              default: ""
          },
          hasCompareValue: {
              type: Boolean,
              default: false
          },
          extra: {
              type: String,
              default: ""
          }
      },
      data: function() {
          return {
              defaultCompareValue: defaultCompareValue
          };
      },
      computed: {
          isLower: function() {
              if (this.compareValue && this.compareValue !== defaultCompareValue) {
                  return this.compareValue.includes("-");
              }
              return false;
          },
          isHigher: function() {
              if (this.compareValue && this.compareValue !== defaultCompareValue) {
                  return this.compareValue.includes("+");
              }
              return false;
          }
      }
  };
</script>
<style lang="scss">
@import "./_common.scss";
.data-item {
  @extend .data-hover-item;
  .item-name {
    line-height: 20px;
    color: #60666e;
    font-weight: normal;
    user-select: none;
    .extra {
      margin-left: 4px;
      display: inline-block;
      border-radius: 2px;
      border: #c6cacf 0.5px solid;
      line-height: 15px;
      height: 16px;
      font-size: 12px;
      color: #60666e;
      padding: 1px 2px;
      transform: translateY(-1px);
    }
  }
  .item-value {
    margin-top: 12px;
    margin-bottom: 6px;
    .value {
      font-size: 34px;
      line-height: 0.85;
      color: #142c3d;
    }
    .unit {
      font-size: 16px;
      line-height: 0.91;
      color: #142c3d;
    }
  }
  .compare-name {
    user-select: none;
    display: block;
    font-size: 12px;
    color: #93999f;
    line-height: 17px;
    margin-bottom: 8px;
  }
  .compare-value {
    user-select: none;
    display: inline-block;
    border-radius: 100px;
    height: 18px;
    line-height: 18px;
    background-color: #d4d4d4;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    padding: 0 10px;
    &.higher {
      background-image: linear-gradient(245deg, #ff4116, #ff2851);
      box-shadow: 0 0 8px 0 rgba(255, 52, 51, 0.22);
    }
    &.lower {
      background-image: linear-gradient(245deg, #0cde65, #2dd58a);
      box-shadow: 0 0 8px 0 rgba(173, 249, 212, 0.7);
    }
  }
}
</style>




// WEBPACK FOOTER //
// dataItem.vue?95ebe6b8